module.exports = __webpack_public_path__ + "static/media/right_arrow.2da877b5.svg";